<canvas
  #canvas
  [width]="width"
  [height]="height"
  style="display: none"
></canvas>
